import {PropTypes} from "prop-types";
import {product as productStore} from "@/store/Product";
import {useTranslation} from "react-i18next";

const AddToCart = ({label, onAddToCart, disabled}) => {
  const {t} = useTranslation();

  const handleOnClick = async e => {
    e.preventDefault();
    const result = await productStore.addToCart();
    onAddToCart && (await onAddToCart());
    return result;
  };

  return (
    <button
      className="button button--quaternary bg-deep-green px-8 py-4 text-base font-normal not-italic leading-[140%] tracking-[0.01rem] md:bg-dark-green add-to-cart-element"
      onClick={handleOnClick}
      disabled={disabled}
    >
      {label ?? t("action.add_to_cart")}
    </button>
  );
};

AddToCart.propTypes = {
  onAddToCart: PropTypes.func,
  label: PropTypes.node,
  disabled: PropTypes.bool,
};

export default AddToCart;
